
import { useState, Fragment } from "react"
import { Box, Button, Tab, Tabs } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneModal from "../../../../Components/OneModal/OneModal"
import { Domain, Lightbulb, MeetingRoom, PhotoCameraFront, Restore, LocalPoliceRounded } from "@mui/icons-material"
import { DadosTab } from "./DadosTab/DadosTab"
import EntradasTab from "./EntradasTab/EntradasTab"
import AutomacaoTab from "./AutomacaoTab/AutomacaoTab"
import ListaRonda from "./RondaTab/ListaRonda"
import CamerasAppTab from "./CamerasAppTab/CamerasAppTab"
import HorariosAba from "./HorariosAba/HorariosAba"

export const CadastroCondominio = ({ openCadastro, setOpenCadastro, idCentral, idToEdit, setIdToEdit, tipoCondominio }) => {
    const [tipoCondominioState, setTipoCondominioState] = useState(tipoCondominio)

    const tabsOptions = [
        {
            label: "Dados",
            componente: DadosTab,
            icon: Domain,
            props: { idToEdit, setIdToEdit, setOpenCadastro, setTipoCondominioState }
        },
        {
            label: "Entradas",
            componente: EntradasTab,
            icon: MeetingRoom,
            props: { idToEdit, setIdToEdit, setOpenCadastro, idCentral }
        },
        {
            label: "Automação",
            componente: AutomacaoTab,
            icon: Lightbulb,
            props: { idToEdit, setIdToEdit, setOpenCadastro, idCentral }
        },
        {
            label: "Cameras App",
            componente: CamerasAppTab,
            icon: PhotoCameraFront,
            props: { idToEdit, setIdToEdit, setOpenCadastro, idCentral }
        },
        {
            label: "Ronda",
            componente: ListaRonda,
            icon: LocalPoliceRounded,
            props: { idToEdit, setIdToEdit, setOpenCadastro, idCentral }
        }
    ]

    if (tipoCondominioState == 2) {
        tabsOptions.splice(tabsOptions.length - 1, 0,
            {
                label: "Horário",
                componente: HorariosAba,
                icon: Restore,
                props: { idCond: idToEdit, setIdToEdit, setOpenCadastro, idCentral }
            }
        )
    }

    const [tabIndex, setTabIndex] = useState(0)

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex)
    }

    return (
        <OneModal
            open={openCadastro}
            setOpen={setOpenCadastro}
            titleText="Condomínio / Empresa"
            FooterButtons={tabIndex == 0 ? FooterButtons : null}
            fullWidth={true}
            onClose={false}
        >
            <Grid sx={{ width: '100%', height: '100%', minHeight: '400px', padding: '0px', display: 'flex', flexFlow: 'column' }}>
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    sx={{
                        flexGrow: 0,
                        flexBasis: 'auto',
                        padding: 0,
                        margin: 0,
                        // borderBottom: '1px solid white',
                        height: '35px',
                        minHeight: '35px',
                        color: "#fff",
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root': {
                            padding: 1,
                            margin: 0,
                            minHeight: '35px',
                            height: '35px',
                            color: "#838383 !important",
                            borderBottom: '1px solid #8A05BE',
                            fontSize: '0.8vmax',
                            fontWeight: 700
                        },
                        '& .Mui-selected': {
                            color: "#3f3f3f !important",
                            fontWeight: 900,
                            borderLeft: '#8A05BE solid 0.5px',
                            borderRight: '#8A05BE solid 0.5px',
                            borderTop: '#8A05BE solid 0.5px',
                            borderBottom: '0px',
                            borderRadius: '5px 5px 0 0',
                            padding: 1,
                            margin: 0
                        }
                    }}
                >
                    {tabsOptions.map((tab) => {
                        return (
                            <Tab
                                key={tab.label}
                                icon={<tab.icon/>}
                                iconPosition="start"
                                label={<Box component='span' sx={{ fontSize: { xl: '13px' } }}>{tab.label}</Box>}
                            />
                        )
                    })}
                </Tabs>

                <Grid container sx={{ paddingTop: '10px', display: 'flex', flexBasis: 'auto', flexGrow: 1, overflowY: 'hidden' }}>
                    {tabsOptions.map((tab, index) => {
                        return (
                            <Fragment key={index}>
                                {tabIndex === index &&
                                <tab.componente {...tab.props} key={tab.label}/>
                                }
                            </Fragment>
                        )
                    })}
                </Grid>

            </Grid>
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="condominio-form" type="submit">Salvar</Button>
        </Grid>
    )
}
